import {
  skipToken,
  useInfiniteQuery,
  infiniteQueryOptions
} from '@tanstack/react-query'
import type { StoreApiFetchProductsRequest } from '@itsrever/rever-api'
import { storeApi } from '@/redux/api/store-api-slice'

export const storeProductsQuery = ({
  ecommerceId,
  language,
  countryCode,
  orderCurrency,
  filterText,
  resourceId,
  resourceType,
  pageInfoStartCursor,
  pageInfoPageSize = 20,
  orderReference
}: Partial<StoreApiFetchProductsRequest>) =>
  infiniteQueryOptions({
    queryKey: [
      'store-products',
      ecommerceId,
      language,
      countryCode,
      orderCurrency,
      filterText,
      resourceId,
      resourceType,
      pageInfoPageSize,
      pageInfoStartCursor,
      orderReference
    ],
    queryFn:
      ecommerceId !== undefined &&
      language !== undefined &&
      countryCode !== undefined &&
      orderCurrency !== undefined
        ? async ({ pageParam }: { pageParam?: string }) => {
            const { data } = await storeApi.fetchProducts({
              ecommerceId,
              language,
              countryCode,
              orderCurrency,
              filterText,
              resourceId,
              resourceType,
              pageInfoStartCursor: pageParam,
              pageInfoPageSize,
              orderReference
            })

            return data
          }
        : skipToken,
    retry: false,
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => {
      if (lastPage?.page_info?.has_next_page) {
        return lastPage.page_info?.end_cursor
      }
      return undefined
    },
    staleTime: 10 * 60 * 1000 // 10 minutes
  })

export const useStoreProducts = ({
  ecommerceId,
  language,
  countryCode,
  orderCurrency,
  filterText,
  resourceId,
  resourceType,
  pageInfoStartCursor,
  pageInfoPageSize,
  orderReference
}: Partial<StoreApiFetchProductsRequest>) => {
  return useInfiniteQuery(
    storeProductsQuery({
      ecommerceId,
      language,
      countryCode,
      orderCurrency,
      filterText,
      resourceId,
      resourceType,
      pageInfoStartCursor,
      pageInfoPageSize,
      orderReference
    })
  )
}
